document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const openBtn = document.querySelector('.menu-toggle');
  const closeBtn = document.querySelector('.close-menu');
  const menu = document.querySelector('.mobile-menu');

  function setMenu(open) {
    body.classList.toggle('menu-open', open);
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (menu) menu.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  if (openBtn) openBtn.addEventListener('click', () => setMenu(true));
  if (closeBtn) closeBtn.addEventListener('click', () => setMenu(false));
  if (menu) menu.addEventListener('click', (event) => {
    if (event.target === menu) setMenu(false);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenu(false);
  });
});

// Product page improvements: image thumbnails and live price update
window.addEventListener('DOMContentLoaded', () => {
  const mainImage = document.querySelector('#ProductMainImage');
  const thumbs = document.querySelectorAll('.product-thumb');
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.src = thumb.dataset.image;
      mainImage.alt = thumb.dataset.alt || mainImage.alt;
      thumbs.forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  const variantSelect = document.querySelector('#ProductVariantSelect');
  const priceEl = document.querySelector('#ProductPrice');
  const compareEl = document.querySelector('#ProductCompare');
  if (variantSelect && priceEl) {
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      if (option?.dataset.price) priceEl.textContent = option.dataset.price;
      if (compareEl) {
        compareEl.textContent = option?.dataset.compare || '';
        compareEl.style.display = option?.dataset.compare ? '' : 'none';
      }
    });
  }
});
